<template>
  <SiteNavbar />

  <div class="layout__view">
    <RouterView v-slot="{ Component }">
      <Transition name="page" mode="out-in" appear>
        <component v-if="$beet.isReady" :is="Component" :key="$route.name" class="page" />
      </Transition>
    </RouterView>
  </div>

  <SiteFooter v-if="$beet.isReady" class="layout__footer" />

  <Gdpr :options="{ backgroundColor: '#f3f3f3', color: '#041e42', solid: true }" />
</template>

<script>
import Gdpr from '@/components/gdpr/Gdpr.vue'
import MobileNav from '@/components/nav/MobileNav.vue'
import SiteNavbar from '@/components/nav/SiteNavbar.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import { useLangRouter } from '@/extensions/langRouter'

export default {
  name: 'App',
  setup() {
    useLangRouter()
  },
  components: { Gdpr, MobileNav, SiteFooter, SiteNavbar },
  watch: {
    '$i18n.locale': {
      handler: function (to) {
        this.$beet.fetchCoreData(to)
        this.$store.dispatch('clearData')
      },
      immediate: true,
    },
  },
  mounted() {
    window.setTimeout(() => {
      if (this.$route.hash)
        document
          .getElementById(this.$route.hash.replace('#', ''))
          ?.scrollIntoView({ behavior: 'smooth' })
    }, 1000)
  },
}
</script>
